import React from "react";
//#region types
import { ComponentBaseProps } from "models/propTypes/basePropTypes";
//#endregion
//#region components
import lottieSuccess from "images/lottie-success-blue.json";
import { Skeleton } from "@mui/material";
import Lottie from "lottie-react";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import clsx from "clsx";

const LoadingSuccess: React.FC<ComponentBaseProps> = (props) => {
  return (
    <Skeleton className={clsx(cssExports.successLoading, props.className)}>
      <Lottie className={cssExports.player} animationData={lottieSuccess} autoplay />
    </Skeleton>
  );
};

export default LoadingSuccess;
